import { authRoleAccess } from 'auth/AuthRoleAccess'
import { lazy } from 'react'
    
const SocialMedia = lazy(() => import ('./SocialMedia.jsx'))  

const SocialMediaRoutes = [
    {
        path: '/SocialMedia',
        component: SocialMedia,
        auth: authRoleAccess.manage_social_media,
    },
   
]

export default SocialMediaRoutes 